module.exports = __webpack_public_path__ + "img/baseballcap_left.16f1b907.png";